export const activityStatusTimeoutInSeconds = 60; // 1 minute
export const activityStatusTimeout = activityStatusTimeoutInSeconds * 1000; // 1 minute
export const activityStatusTimeoutBuffer = 5 * 1000; // 5 seconds

export const activityStatusStringTypeArray = ['active', 'inactive'] as const;

export type ActivityStatusStringType =
  (typeof activityStatusStringTypeArray)[number];

export type ActivityStatusResult =
  | { userId: string; status: 'active'; expiresAt: number }
  | { userId: string; status: 'inactive'; expiresAt?: undefined };
